<script>
import resources from './resources'

export default {
  name: 'links-profile',
  mixins: [resources]
}
</script>

<template lang="pug">
ul
  //- social linkedin
  a(v-if="links.linkedin", :href="links.linkedin", target="_blank")
    li
      img(src="/static/images/icons/linkedin-icon.svg")
  a.mb-cursor-point(v-if="!links.linkedin")
    li
      img(src="/static/images/icons/linkedin-icon.svg")

  //- profile professional
  a.cursor-point(
    @click.prevent="openProfileCompany(countryRegsiter, documentState, state)"
  )
    li
      img(src="/static/images/icons/perfil-icon.svg")

  //- social professional lattes
  //- a(v-if="links.lattes", :href='links.lattes', target="_blank")
  //-   li
  //-     img(src='/static/images/icons/share-icon.svg')
  //- a.mb-cursor-point(v-if="!links.lattes")
  //-   li
  //-    img(src='/static/images/icons/share-icon.svg')
</template>
<style scoped>
@media (max-device-height: 736px) {
  ul li img {
    padding-left: 40px;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/patient/loading-page/components/links-profile-company/links.vue